/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EditSilenceReasonRequest
 */
export interface EditSilenceReasonRequest {
  /**
   *
   * @type {string}
   * @memberof EditSilenceReasonRequest
   */
  alarmId: string;
  /**
   *
   * @type {string}
   * @memberof EditSilenceReasonRequest
   */
  reason?: string | null;
}

/**
 * Check if a given object implements the EditSilenceReasonRequest interface.
 */
export function instanceOfEditSilenceReasonRequest(
  value: object,
): value is EditSilenceReasonRequest {
  if (!("alarmId" in value) || value["alarmId"] === undefined) return false;
  return true;
}

export function EditSilenceReasonRequestFromJSON(
  json: any,
): EditSilenceReasonRequest {
  return EditSilenceReasonRequestFromJSONTyped(json, false);
}

export function EditSilenceReasonRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EditSilenceReasonRequest {
  if (json == null) {
    return json;
  }
  return {
    alarmId: json["alarmId"],
    reason: json["reason"] == null ? undefined : json["reason"],
  };
}

export function EditSilenceReasonRequestToJSON(
  json: any,
): EditSilenceReasonRequest {
  return EditSilenceReasonRequestToJSONTyped(json, false);
}

export function EditSilenceReasonRequestToJSONTyped(
  value?: EditSilenceReasonRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    alarmId: value["alarmId"],
    reason: value["reason"],
  };
}
